export default "__VITE_ASSET__CXgneBSn__"